import './index.scss';
import * as React from 'react';
import { useState, useEffect } from 'react';
import { noop } from '../../lib/utils';

import { EmptyData } from '../../lib/components/EmptyData';

function FormCheckSelect({
  data: { label, options, multi },
  setFormValue: iSetFormValue,
}) {
  const setFormValue = iSetFormValue || noop;
  const [values, setValues] = useState(options.length ? [options[0]] : []);

  const onSelect = i => {
    if (!multi) {
      return setValues([i]);
    }

    if (values.length === 1 && i === values[0]) {
      return;
    }

    if (values.includes(i)) {
      return setValues(values.filter(item => item !== i));
    }
    setValues([...values, i]);
  };

  useEffect(() => {
    setFormValue({ key: label, value: values.join(', ') });
  }, [values]);

  if (!iSetFormValue) {
    return <EmptyData text="该组件只能作为[辅导表单容器]的子组件" />;
  }

  return (
    <div className="fudao-form-item fudao-check-select">
      <p className="fudao-check-select-title">
        选择
        {label}
      </p>
      <div className="fudao-check-select-options">
        {options.map((i, index) => (
          <div
            className={values.includes(i) ? 'selected' : ''}
            key={index}
            onClick={() => onSelect(i)}
          >
            {i}
          </div>
        ))}
      </div>
    </div>
  );
}

export default FormCheckSelect;
